<template>
    <transition name="slide-fade">
        <div class="modal" :class="{ 'open': open }" v-if="open">
            <div class="modal-content">
                <div class="w-full min-h-full py-12 lg:py-0 bg-a-egg-f5ebdc text-a-brown-502314 lg:rounded-20 lg:px-14 lg:my-6">
                    <div class="font-bold text-center py-4 lg:text-18">{{ lbl.myOrder.popupTitle }}</div>
                    <div class="absolute top-14 lg:top-10 right-4 flex">
                        <button type="button" class="outline-none appearance-none bg-none" @click="clickCancel()">
                            <img class="ml-auto mr-0" src="@/assets/icon/ic-close-brown.svg" />
                        </button>
                    </div>
                    <Header></Header>
                    <DeliveryStatus></DeliveryStatus>
                    <OrderDetail></OrderDetail>
                    <div class="flex">
                        <div class="w-52 m-auto pb-4">
                            <Contact @onClick="onClickContactCC()"></Contact>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import { inject, computed as vueComputed } from "vue";
import Util from "@/helper/Utility.js";
import DatetimeHelper from "@/helper/DatetimeHelper.js";
//mixin
import LocaleMixin from "@/mixin/LocaleMixin.js";
//component
import Header from "../../component/OrderDeliveryDetail/Header.vue";
import DeliveryStatus from "../../component/OrderDeliveryDetail/DeliveryStatus.vue";
import OrderDetail from "../../component/OrderDeliveryDetail/OrderDetail.vue";
import Contact from "../../component/OrderDeliveryDetail/Contact.vue";


export default {
    name: "OrderDeliveryDetailModal",
    mixins: [LocaleMixin],
    components: {
        Header,
        DeliveryStatus,
        OrderDetail,
        Contact
    },
    props: {
        controller: Object,
    },
    data: function () {
        return {
            open: false,

            title: '',
            message: '',
            orderItem: null,
            orderDetail: [],
            total: 0,
            btnOk: '',
            btnCancel: '',
            busModal: null,
        };
    },
    provide: function () {
        return {
            getTracking: vueComputed(() => this.orderItem),
            getOrderItems: vueComputed(() => this.orderDetail)
        }
    },
    setup: function () {
        const { lbl } = inject("LocaleStore")

        return {
            lbl
        }
    },
    created: function () {
        this.busModal = this.controller.busModal;
    },
    mounted: function () {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    methods: {
        show: function (config) {
            this.title = config.title;
            this.message = config.msg;
            this.orderItem = config.orderItem;
            this.orderDetail = config.orderDetail;
            this.btnOk = config.btnOk;
            this.btnCancel = config.btnCancel;


            if (Util.isEmptyStr(this.btnOk)) {
                this.btnOk = this.lbl.button.confirm;
            }
            if (Util.isEmptyStr(this.btnCancel)) {
                this.btnCancel = this.lbl.button.cancel;
            }

            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function () {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk(this.campaignList);
        },
        clickCancel: function () {
            this.hide();
            this.controller.sendCallbackCancel();
        },
        getCompleteDate: function (completeDate) {
            return DatetimeHelper.getDatetimeShortFormat(completeDate);
        },
        onClickContactCC: function(){
            window.open("tel:1122", "_self")
        }
    },
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/base/text.scss";
@import "@/style/modal.scss";

.modal {
    @extend %modal;

    .modal-content {
        width: 100%;
        min-height: 100vh;

        @include min-desktop {
            width: 550px;
            min-height: 0;
        }

    }

    .campaign-name {
        @extend %ellipsis-2;
        max-width: 75%;
    }
}
</style>
